import styled from 'styled-components';

export const tokens = {
  ink: '#122029',
  muted: '#56666E',
  line: '#DCE3E0',
  lineSoft: '#EDF1EF',
  bg: '#F3F5F4',
  card: '#FFFFFF',
  green: '#0A6E53',
  greenDark: '#075A43',
  greenSoft: '#E3F2EC',
  greenText: '#085440',
  amberSoft: '#FDF0D5',
  amberText: '#704700',
  blueSoft: '#E3ECF8',
  blueText: '#1B4C8A',
  redSoft: '#FBE4E0',
  redText: '#8A2A1C',
  red: '#A33A2A',
  graySoft: '#EAEEED',
  grayText: '#43535B',
  navy: '#0D1B24',
  mono: "'IBM Plex Mono', ui-monospace, monospace",
  sans: "'IBM Plex Sans', -apple-system, 'Segoe UI', sans-serif",
};

export const StepBar = styled.span<{ $done: boolean }>`
  display: block;
  height: 4px;
  border-radius: 2px;
  background: ${(p) => (p.$done ? tokens.green : tokens.line)};
`;
export const StepLabel = styled.span<{ $done: boolean }>`
  font-size: 12px;
  font-weight: 600;
  color: ${(p) => (p.$done ? tokens.green : tokens.muted)};
`;

export const Grid = styled.div<{ $cols: number; $gap?: number }>`
  display: grid;
  grid-template-columns: repeat(${(p) => p.$cols}, minmax(0, 1fr));
  gap: ${(p) => p.$gap ?? 12}px;
`;

export const Col = styled.div<{ $gap?: number }>`
  display: flex;
  flex-direction: column;
  gap: ${(p) => p.$gap ?? 8}px;
  min-width: 0;
`;
